const snackbarDefaults = {
            text: 'New Snackbar Alert',
            color: 'primary',
            status: false
        }
export const core = {
    state: {
        savingStatus: false,
        loader: false,
        errorMsg: false,
        snackbar: { ...snackbarDefaults }
    },
    mutations: {
        'SET_SAVING_STATUS' (state, savingStatus) {
            state.savingStatus = savingStatus
        },
        SET_LOADER(state,loader) {
            state.loader = loader
        },
        SET_ERROR(state,errorMsg) {
            state.errorMsg = errorMsg
        },
        SET_SNACKBAR(state, options) {
            state.snackbar = options
            state.snackbar.status = true
        }
    },
    actions: {
        setSnackbar({commit}, options) {
            commit('SET_SNACKBAR', { ...snackbarDefaults, ...options })
        },
        setSavingStatus ({commit} , savingStatus) {
            commit('SET_SAVING_STATUS', savingStatus)
        },
        setLoader({commit},loader) {
            commit('SET_LOADER', loader)
        },
        setErrorMessage ({commit},errorMsg) {
            commit('SET_ERROR', errorMsg)
        }
    }
}
